export default __webpack_public_path__ + "static/media/clown.b0667697.png";